import { useBook } from "hooks/useBook";
import { Footer } from "layout/Footer";
import { observer } from "mobx-react";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import emptyStateSearch from "../../assets/images/svg/empty_state_search.svg";
import { AdditionalsItem } from "../AdditionalsItem/AdditionalsItem";
import {
  Container,
  FooterContainer,
  StyleCategory,
  StyleContainer,
  StyleImage,
  StyleNoItemsContainer,
  StyleTitle,
} from "./AdditionalsGrid.styled";

export const AdditionalsGrid: React.FC = observer(() => {
  const { t } = useTranslation("home");
  const { fetchAllBooks, booksInfo } = useBook();
  useEffect(() => {
    fetchAllBooks();
  }, [fetchAllBooks]);
  return (
    <Container>
      <StyleContainer>
        {booksInfo?.length > 0 && (
          <>
            <StyleCategory>{t("additionals.additionalsTitle", "My additionals")}</StyleCategory>
            {booksInfo?.map((item, index) => (
              <AdditionalsItem key={item.id ? item.id : index} item={item} />
            ))}
          </>
        )}
        {booksInfo?.length === 0 && (
          <StyleNoItemsContainer>
            <StyleImage alt="empty-state-search" src={emptyStateSearch} />
            <StyleTitle>
              {t("additionals.noItems", "You still don´t have any additionals")}
            </StyleTitle>
          </StyleNoItemsContainer>
        )}
      </StyleContainer>
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </Container>
  );
});
